module.exports = __webpack_public_path__ + "media/images/emblems/Montagny-coat_of_arms-2069ea3fd9ca6fbed6b679c0c9da9c14.svg";